import {
  FontIcon,
  FontIcons,
  InputLooks,
  StandardButton,
  StandardTextfield,
  brandfolderColorPalette,
} from '@brandfolder/react';
import { t, Trans } from '@lingui/macro';
import React, { FunctionComponent, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { TextButton } from '@components/library/button';

import { BackButton } from '../common/BackButton';
import { PersonDetailsParamKeys } from '../customPeopleTagTypes';
import { usePersonDetailsQueryState } from '../hooks/usePersonDetailsQueryState';

const TagPersonWrapper = styled.div`
  align-items: center;
  display: flex;

  button,
  h1,
  img,
  .default-image,
  .search-textfield {
    margin-right: 16px;
  }

  img,
  .default-image {
    border-radius: 4px;
    height: 48px;
    width: 48px;
  }
`;
const DefaultImage = styled.div`
  align-items: center;
  background-color: ${brandfolderColorPalette.neutrals[200]};
  color: ${brandfolderColorPalette.neutrals[500]};
  display: flex;
  justify-content: center;
`;
const TagPeopleTextfieldWrapper = styled.div`
  align-items: center;
  display: flex;

  .search-textfield {
    width: 300px;
  }
`;
const TitleDivider = styled.hr`
  margin: 40px 0;
`;

interface PersonDetailsHeaderProps {
  thumbnail: string;
}
export const PersonDetailsHeader: FunctionComponent<PersonDetailsHeaderProps> = ({ thumbnail }) => {
  const [state, setState] = usePersonDetailsQueryState();
  const [showTagField, setShowTagField] = useState(false);
  const [prevRoute, setPrevRoute] = useState(undefined);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.state) {
      setState({ tag: location.state.label });
      setPrevRoute(location.state.prevRoute);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state]);

  return (
    <>
      <TagPersonWrapper>
        {(!!location.state?.thumbnail || !!thumbnail) ? (
          <img alt="person thumbnail" src={location.state?.thumbnail || thumbnail} />
        ) : (
          <DefaultImage className="default-image">
            <FontIcon icon={FontIcons.UserFilled} iconSize={26} />
          </DefaultImage>
        )}
        <StandardButton
          className={!showTagField && !state.tag ? 'visible' : 'hidden'}
          onClick={(): void => setShowTagField(true)}
          startIcon={FontIcons.Tag}
        >
          <Trans>Tag person</Trans>
        </StandardButton>
        <TagPeopleTextfieldWrapper className={showTagField ? 'visible' : 'hidden'}>
          <StandardTextfield
            id="search-textfield"
            label="Tag person textfield"
            look={InputLooks.Default}
            onChange={(e): void => setState({ [PersonDetailsParamKeys.Tag]: e.target.value })}
            placeholder={t`Enter name`}
            showLabel={false}
            textfieldProps={{ className: 'search-textfield' }}
          />
          <StandardButton
            disabled={!state.tag}
            onClick={(): void => setShowTagField(false)}
          >
            <Trans>Save</Trans>
          </StandardButton>
        </TagPeopleTextfieldWrapper>
        {!showTagField && state.tag && (
          <>
            <h1>{state.tag}</h1>
            <TextButton onClick={(): void => setShowTagField(true)}>
              <Trans>Edit</Trans>
            </TextButton>
          </>
        )}
      </TagPersonWrapper>
      <TitleDivider />
      <BackButton
        handleNavigateBack={(): void => {
          navigate(prevRoute);
        }}
      />
    </>
  );
};
